// Date helpers for booking
export const fmtDate = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const fmtDateSv = (d) =>
  d.toLocaleDateString("sv-SE", { weekday: "short", day: "numeric", month: "long" });
